module.exports = __webpack_public_path__ + "assets/img/linkedin_w.7e5eb74c.svg";